module.exports = __webpack_public_path__ + "img/MM_Main_02.b2ab72da.png";